import React, {useState} from 'react';
import {Form, Button} from 'reactstrap';
import FormInput from '../../../../components/UI/Input/FormInput';

/**
 * RequestOTP - Screen for requesting OTP code via email
 */
function RequestOTP({onOTPRequested}) {
    const [email, setEmail] = useState('');
    const [isValid, setIsValid] = useState(true);
    const [errorMessage, setErrorMessage] = useState('');

    const validateEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        if (!email.trim()) {
            setIsValid(false);
            setErrorMessage('Bitte geben Sie Ihre E-Mail-Adresse ein.');
            return;
        }

        if (!validateEmail(email)) {
            setIsValid(false);
            setErrorMessage('Bitte geben Sie eine gültige E-Mail-Adresse ein.');
            return;
        }

        setIsValid(true);
        setErrorMessage('');
        onOTPRequested(email);
    };

    const handleEmailChange = (e) => {
        setEmail(e.target.value);
        if (errorMessage) {
            setIsValid(true);
            setErrorMessage('');
        }
    };

    return (
        <div>
            <div className="text-center mb-4">
                <h1 className="h2 text-primary mb-3">Herzlich willkommen zum Jury-Voting!</h1>
                <p className="text-muted">
                    Bitte geben Sie Ihre E-Mail-Adresse ein. Wir senden Ihnen einen Einmal-Code zum Anmelden.
                </p>
            </div>

            <Form onSubmit={handleSubmit}>
                <FormInput
                    elementType="input"
                    elementConfig={{
                        label: "Email Adresse",
                        type: "email",
                        placeholder: "mario.dupont@gmail.com",
                        autoComplete: "email",
                        autoFocus: true,
                        columns: 12
                    }}
                    id="jury-email"
                    name="email"
                    value={email}
                    changed={handleEmailChange}
                    invalid={!isValid}
                    errorMessage={errorMessage}
                    touched={true}
                    shouldValidate={true}
                />

                <div className="mt-2 align-content-center justify-content-center d-flex">
                    <Button
                        type="submit"
                        color="primary"
                    >
                        Code anfordern
                    </Button>
                </div>
            </Form>
        </div>
    );
}

export default RequestOTP;
